import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class HideOnScroll {
  constructor(element) {
    this.element = element;

    // tolerance: after scrolling how many pixels should scrolltrigger trigger?
    this.tolerance = element.dataset.tolerance;
    // breakpoint to trigger effect
    this.breakpoint = element.dataset.breakpoint;

    this.init();
  }

  init() {
    const mm = gsap.matchMedia();

    mm.add(this.breakpoint, () => {
		ScrollTrigger.normalizeScroll(true);
      ScrollTrigger.observe({
        target: window,
        type: 'scroll',
        tolerance: this.tolerance,
        onUp: () => {
			window.addEventListener('scroll', function() {
				let scrollPosition = window.scrollY;
				const nav = document.querySelector('.js-nav');

				if (scrollPosition < 150 || scrollPosition == 0) {
				nav.classList.add('no-bg-menu');
				nav.classList.remove('bg-menu');
				} else {
				nav.classList.remove('no-bg-menu');
				nav.classList.add('bg-menu');
				}
			});
			this.element.classList.remove('hide-on-scroll');
		},
        onDown: () => this.element.classList.add('hide-on-scroll'),
      });

      return () => {
        this.element.classList.remove('hide-on-scroll');
      };
    });

    //
  }
}
